import React, { useState, useEffect } from 'react';
import AuthService from '../../../../services/auth';
import { useGet } from '../../../../reducers/useGet';
import ReactLoading from 'react-loading';

import NoDeviceConnectedMessage from '../../messages-panel/no-device-connected-message';
import ErrorMessage from '../../messages-panel/error-message';
import WaterFlowDataAnimalPanel from '../../panel/water-flow-data-animal-panel';
import SumWaterFlowDataAnimalPanel from '../../panel/sum-water-flow-data-animal-panel';

import { hidrometer, flowWaterAccPO, wellLevel, flowWaterAccYF24 } from '../../../../sensors-type';
import WellLevelPanel from '../../panel/well-level-panel/well-level-panel';

export default function PitButtonData({ gateway, sensorsType }) {
	let { access_token } = AuthService.getCurrentUser();
	const [devices, setDevices] = useState([]);

	let getColetores = useGet(`coletor_consulta?coletor_gateway=${gateway.id}`, access_token);
	let getSensors = useGet(`sensor_consulta?sensor_concentrador=${gateway.id}`, access_token);

	useEffect(() => {
		if (
			!getColetores.state.loading &&
			!getColetores.state.error &&
			!getSensors.state.loading &&
			!getSensors.state.error
		) {
			let sensors = getSensors.state.data.map((s) => {
				let type = sensorsType.filter((el) => s.tipo === el.id);

				if (type.length > 0) {
					s.tipo = type[0].nome;
				}
				return s;
			});

			let devicesList = getColetores.state.data.map((d) => {
				let sensor = sensors.filter(
					(s) => d.id === s.coletor && (s.tipo === hidrometer || s.tipo === flowWaterAccPO || s.tipo === wellLevel || s.tipo === flowWaterAccYF24)
				);
				if (sensor.length > 0) return { datalogger: d, sensorsList: sensor[0] };
				return null;
			});
			devicesList = devicesList.filter(Boolean);
			setDevices(devicesList);
		}
	}, [
		getColetores.state.loading,
		getColetores.state.error,
		getColetores.state.data,
		getSensors.state.loading,
		getSensors.state.error,
		getSensors.state.data,
		sensorsType,
	]);

	// Funções auxiliares para renderização

	const isLoading = getColetores.state.loading || getSensors.state.loading;

	const hasError = getColetores.state.error || getSensors.state.error;

	const renderLoading = () => (
		<div className="loading-container">
			<ReactLoading type="bubbles" color="var(--main-color)" width="50px" height="50px" />
		</div>
	);

	const renderError = () => <ErrorMessage />;

	const renderNoDevices = () => <NoDeviceConnectedMessage />;
	const flowSensors = devices
		.map((device) => device.sensorsList)
		.filter((sensor) => sensor && sensor.tipo !== wellLevel);

	const renderDevices = () => (
		<div className="show-data-container" style={{ padding: '10px' }}>
			{flowSensors.length > 1 && <SumWaterFlowDataAnimalPanel sensors={flowSensors} />}
			<div className="grid-container">
				{devices.map((d) =>
					d.sensorsList ? (
						d.sensorsList.tipo === wellLevel ? (
							<div key={d.datalogger.id}>
								<WellLevelPanel sensor={d.sensorsList} />
							</div>
						) : (
							<div key={d.datalogger.id}>
								<WaterFlowDataAnimalPanel sensor={d.sensorsList} />
							</div>
						)
					) : null
				)}
			</div>
		</div>
	);

	// Render principal

	return (
		<div className="dropdown-button-line">
			{isLoading
				? renderLoading()
				: hasError
				? renderError()
				: devices.length === 0
				? renderNoDevices()
				: renderDevices()}
		</div>
	);
}
